<template>
  <div class="study-rank">
    <chooseState :chooses="chooses"></chooseState>
    <studyTable :tableData="tableDataTemp" :columns="columns" :num="num" :pages="pages"></studyTable>
  </div>
</template>
<script>
import chooseState from "./module/_studyChoose";
import studyTable from "./module/_studyTable";
export default {
  data() {
    return {
      tableData: [],
      columns: [
        { name: "上传对象", prop: "areaname" },
        { name: "上传条数", prop: "count" }
      ],
      chooses: [{ name: "按乡/镇查询" }, { name: "按村/社区查询" }],
      pages: 1,
      tableDataTemp: [],
      num:1,
      choosed:1

    };
  },
  components: {
    chooseState,
    studyTable
  },
  methods: {
    getMsg() {
      this.tableDataTemp = [];
      this.axios
        .post("/api/Statistics/Post", {
          c1roleid: sessionStorage.getItem("roleid"),
          c2name: sessionStorage.getItem("token"),
          c2town: sessionStorage.getItem("town"),
          c1status: this.choosed
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.tableData = e.data.msg;
              this.num = this.tableData.length
              this.tableData.some((item, index) => {
                if (index == 10) return true;
                else {
                  // let _name= (item.name==undefined?'':'/'+item.name)
                  // this.tableDataTemp.push({areaname:(item.areaname+ _name),count:item.count})
                  this.tableDataTemp.push(item)

                  // console.log(this.tableDataTemp);
                  
                }
              });
              this.pages = Number.parseInt(this.tableData.length%10>0?this.tableData.length/10+1:this.tableData.length);
              console.log(this.pages);
              
              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.study-rank {
  padding-top: 1.1rem;
  font-size: 0.3rem;
}
</style>